export default __webpack_public_path__ + "static/media/Quadcopter.5b09aaa5.jpg";